import { useSyncExternalStore } from 'react';

// Read straight from matchMedia instead of framer-motion's useReducedMotion: framer caches the
// preference in module state the first time any component asks, so a later change of the OS
// setting (or of the test stub) never reaches components mounted afterwards. HeroVideo reads the
// same query the same way.
const CONSULTA_MOVIMIENTO_REDUCIDO = '(prefers-reduced-motion: reduce)';

function consulta(): MediaQueryList | null {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
    return window.matchMedia(CONSULTA_MOVIMIENTO_REDUCIDO);
}

function suscribirMovimiento(aviso: () => void): () => void {
    const lista = consulta();
    lista?.addEventListener('change', aviso);
    return () => lista?.removeEventListener('change', aviso);
}

function leerMovimientoReducido(): boolean {
    return consulta()?.matches ?? false;
}

function suscribirVisibilidad(aviso: () => void): () => void {
    document.addEventListener('visibilitychange', aviso);
    return () => document.removeEventListener('visibilitychange', aviso);
}

function leerPestanaOculta(): boolean {
    return document.hidden;
}

function enServidor(): boolean {
    return false;
}

export function usePrefiereMovimientoReducido(): boolean {
    return useSyncExternalStore(suscribirMovimiento, leerMovimientoReducido, enServidor);
}

export function usePestanaOculta(): boolean {
    return useSyncExternalStore(suscribirVisibilidad, leerPestanaOculta, enServidor);
}
